import { render } from "./NetworkUser.vue?vue&type=template&id=887cbc26&scoped=true"
import script from "./NetworkUser.vue?vue&type=script&lang=js"
export * from "./NetworkUser.vue?vue&type=script&lang=js"

import "./NetworkUser.vue?vue&type=style&index=0&id=887cbc26&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887cbc26"]])

export default __exports__